/* eslint react-hooks/exhaustive-deps: "warn" */

import { Icon } from 'ui/atoms/Icon/Icon';
import { Section } from 'ui/molecules/Section/Section';

import styles from './DeliveryChannels.module.scss';

import type { DeliveryChannelsProps } from './DeliveryChannels.types';

export const DeliveryChannels = ({ label, channels }: DeliveryChannelsProps) => (
  <Section align="left" extra={label}>
    <div className={styles.items}>
      {channels.map((channel) => (
        <a key={channel.key} className={styles.item} href={channel.href} target="_blank" rel="noopener noreferrer">
          <div className={styles.icon}>
            <Icon type={channel.iconType} size="md" />
          </div>

          <div className={styles.body}>
            <span className={styles.name}>{channel.name}</span>

            <span className={styles.link}>
              {channel.linkLabel} <span className={styles.arr}>→</span>
            </span>
          </div>
        </a>
      ))}
    </div>
  </Section>
);
